/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  DatevRieckenUpsellingRequest,
  DatevRieckenUpsellingResponse,
  DemoRedirectUrlDto,
  DemoUserDetailDto,
  GetDemoRedirectUrlParams,
  PlatformConnectionRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAccountingPlatformDemoController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-accounting-platform-demo-controller
   * @name GetUpsellingInfo
   * @request GET:/api/v1/accounting-integration/platform/upsell
   */
  getUpsellingInfo = (params: RequestParams = {}) =>
    this.http.request<DatevRieckenUpsellingResponse, any>({
      path: `/v1/accounting-integration/platform/upsell`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getUpsellingInfoPath = '/v1/accounting-integration/platform/upsell'
  static getUpsellingInfoMethod = 'GET'
  /**
   * No description
   *
   * @tags api-accounting-platform-demo-controller
   * @name Upsell
   * @request POST:/api/v1/accounting-integration/platform/upsell
   */
  upsell = (data: DatevRieckenUpsellingRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/accounting-integration/platform/upsell`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static upsellPath = '/v1/accounting-integration/platform/upsell'
  static upsellMethod = 'POST'
  /**
   * No description
   *
   * @tags api-accounting-platform-demo-controller
   * @name RegisterToPlatform
   * @request POST:/api/v1/accounting-integration/platform/registration
   */
  registerToPlatform = (data: PlatformConnectionRequest, params: RequestParams = {}) =>
    this.http.request<DemoUserDetailDto, any>({
      path: `/v1/accounting-integration/platform/registration`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static registerToPlatformPath = '/v1/accounting-integration/platform/registration'
  static registerToPlatformMethod = 'POST'
  /**
   * No description
   *
   * @tags api-accounting-platform-demo-controller
   * @name GetDemoRedirectUrl
   * @request GET:/api/v1/accounting-integration/platform/connection-url
   */
  getDemoRedirectUrl = (query: GetDemoRedirectUrlParams, params: RequestParams = {}) =>
    this.http.request<DemoRedirectUrlDto, any>({
      path: `/v1/accounting-integration/platform/connection-url`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getDemoRedirectUrlPath = '/v1/accounting-integration/platform/connection-url'
  static getDemoRedirectUrlMethod = 'GET'
}
